import { Stack } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { RoutingOverrideLine } from "./routing-override-line"

/**
 * What a task's assignment overrides and the conditional rules it ignores, listed in the
 * tooltip beside the task's route in the schedule drawer.
 */
export function RoutingNotes({ notes }) {
    return (
        <Stack spacing={0.25}>
            <Repeat list={notes} pass="text" item={<RoutingOverrideLine />} />
        </Stack>
    )
}
